<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="资金账户">
      <template v-if="hasPermission('配置-资金账户-新增')">
        <el-button
          icon="el-icon-plus"
          size="small"
          type="primary"
          @click="newlyAdded"
          >新增资金账户</el-button
        >
      </template>
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <template v-if="hasPermission('配置-资金账户-编辑')">
            <div class="button button_modify" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
          </template>

          <template v-if="hasPermission('配置-资金账户-编辑')">
            <div class="button button_revoke" @click="switchingStates(row.row)">
              <i
                :class="
                  row.row.status == 0
                    ? 'iconfont icon-lock'
                    : 'iconfont icon-jihuo'
                "
              ></i
              >{{ row.row.status == 0 ? "锁定" : "激活" }}
            </div>
          </template>

          <template v-if="hasPermission('配置-资金账户-编辑')">
            <div class="button button_revoke" @click="setSystem(row.row)">
              <i class="iconfont icon-bianji"></i> 设为系统账户
            </div>
          </template>

          <template v-if="hasPermission('配置-资金账户-删除') && row.row.is_system !== 1">
            <div class="button button_revoke" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  companyAccountGetList,
  companyAccountLock,
  companyAccountDel,
  companyAccountActive,
  getshoplist,
  companyAccountSetSystem,
} from "@/api/basicConfiguration";
// 默认参数
import { getRoles } from "@/utils";
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "fundAccount",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        operationWidth: "400px",
        loading: false,
        search: [
          {
            label: "名称",
            type: "input",
            key: "keywords",
          },
          {
            label: "类型",
            type: "select",
            key: "level",
            options: [
              {
                label: "正常",
                value: 1,
              },
              {
                label: "贷款",
                value: 2,
              },
              {
                label: "品牌垫付",
                value: 3,
              },
            ],
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "启用",
                value: 0,
              },
              {
                label: "禁用",
                value: 1,
              },
            ],
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "account_number",
          },
          {
            label: "账户名称",
            prop: "account_name",
          },
          {
            label: "账户级别",
            prop: "level",
            filter: "supplyLevel",
          },
          {
            label: "余额",
            prop: "money",
            isMoney: true,
          },
          {
            label: "系统账户",
            prop: "is_system",
            filter: "isYes",
          },
          {
            label: "状态",
            prop: "status",
            filter: "storeStatus",
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    // 初始化列表内容
    this.getlist();
  },
  computed: {
    ...mapGetters(["hasPermission"]),
  },
  methods: {
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        companyAccountLock({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        companyAccountActive({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 设置为系统账户
    setSystem(row) {
      if (row.is_system == 1) {
        this.$message.success("已经是系统账户，无需再次设定");
        return;
      }
      this.$confirm(
        "商户只能有一个系统账户,此操作将把本账户设为系统账户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        companyAccountSetSystem({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("设定成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      if (row.is_system === 1) {
        this.$message.error("系统账户不能删除");
        return;
      }
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        companyAccountDel({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;
      this.basicListconfig.searchParameters.is_showAll = 1;
      companyAccountGetList(this.basicListconfig.searchParameters).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.basicListconfig.data = res.data;
            this.basicListconfig.total = res.count;
          } else {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/fundAccount/index.vue